import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Autocomplete,
  TextField,
  Chip,
  Box,
} from '@mui/material';
import { useOpportunities } from '../../contexts/OpportunitiesContext';

interface TokenExclusionFilterProps {
  excludedTokens: string[];
  onChange: (tokens: string[]) => void;
}

const TokenExclusionFilter: React.FC<TokenExclusionFilterProps> = ({
  excludedTokens,
  onChange,
}) => {
  const { t } = useTranslation();
  const { opportunities } = useOpportunities();
  
  // Extract unique base currencies from opportunities
  const availableTokens = useMemo(() => {
    const tokens = new Set<string>();
    // opportunities is now an object, so we need Object.values()
    Object.values(opportunities).forEach(opp => {
      if (opp.base) {
        tokens.add(opp.base);
      }
    });
    return Array.from(tokens).sort();
  }, [opportunities]);

  return (
    <Box mb={2}>
      <Autocomplete
        multiple
        id="token-exclusion-filter"
        options={availableTokens}
        value={excludedTokens}
        onChange={(_, newValue) => onChange(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t('settings.filters.excludedTokens')}
            placeholder={t('settings.filters.excludedTokensPlaceholder')}
            helperText={t('settings.filters.excludedTokensHelperText')}
          />
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              label={option}
              {...getTagProps({ index })}
              key={option}
            />
          ))
        }
        fullWidth
        disableCloseOnSelect
      />
    </Box>
  );
};

export default TokenExclusionFilter;